/**
 * 接口域名的管理
 */
const base = {
// system:'/api',//dev调试地址
system:'http://www.tomal.cn/web/api/front',//服务器地址
};

export default base;
